import * as angular from "angular";
import {CustomFieldModel} from "../../site-preferences/models/custom-field.model";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozPackageField', bringozPackageField);

function bringozPackageField(splitService) {
  return function bringozPackageFieldFilter(id) {

    const fields = splitService.getCustomPackageFields();

    if (!id) {
      return '';
    } else {
      const field = _.find(fields, (f: CustomFieldModel) => {
        return f.id === id;
      })
      return field?.name || '';
    }

  }
}
